import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { publicRoutes } from './modules/public/public-routing.module';
import { authRoutes } from './modules/auth/auth-routing.module';

// Main routes (including '', patient/:id, client, messaging, **) come from MainModule.forChild().
// Root only defines public + auth so the catch-all does not run first.
export const routes: Routes = [
  ...publicRoutes,
  ...authRoutes
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      //enableTracing: true,
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
